import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F7004Service {

  constructor(private http: HttpClient) { }

  savef7004(baseUrl: string, returnClobSettingsObj: any, f7004SaveDtls: any[], globalService: any, filterParams: any = {}, rowData: any = {}): Observable<any> {
    // Use the correct endpoint with action_code like in original AngularJS
    // baseUrl already contains /gtw when passed from GENERAL_CONFIG.base_url
    const url = `${baseUrl}/saveJsonObject?action_code=hnwt0q`;
    
    // Use filter parameters passed from component (replaces workspaceFactory.activeScreen.filters.getFilterParams())
    // filterParams are now passed directly from AngularJS

    // Build checkLockedbj like in original AngularJS using rowData (like original!)
    const checkLockedbj: any[] = [];
    
    checkLockedbj.push({
      "leid": rowData.LEID || rowData.SOURCE_LEID,
      "cdr_number": rowData.CDR_NO || rowData.TAX_CODE || rowData.SOURCE_CDR_NO, 
      "consol_group_key": String(rowData.CONSOL_GROUP_KEY || rowData.FILING_GROUP),
      "reporting_period": String(rowData.REPORTING_PERIOD || rowData.SOURCE_REPORTING_PERIOD),
      "combination_key": String(rowData.COMBINATION_KEY || rowData.COMPL_COMBINATION_KEY || returnClobSettingsObj.combination_key),
      "scenario_key": parseInt(filterParams.scenario || globalService?.globalParams?.scenario || 74)
    });
    


    // Build payload structure exactly like in original AngularJS
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ clob_data: JSON.stringify(f7004SaveDtls) }, params);
    params = _.extend({ clob_settings: JSON.stringify(returnClobSettingsObj) }, params);
    params.process_name = "F7004_SAVE";
    
    // Add checkLockedbj - this is crucial!
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Add filing_key from original payload (rowData.CONSOL_GROUP_KEY like in original F7004Ctrl.js)
    if (rowData.CONSOL_GROUP_KEY) {
      params.filing_key = rowData.CONSOL_GROUP_KEY;
    }

    // Add scenarioCode and is_issue_key_enabled from rowData if missing
    if (!params.scenarioCode) {
      // Try to extract rowData from f7004SaveDtls to get SCENARIO_TYPE_CODE
      if (f7004SaveDtls && f7004SaveDtls.length > 0) {
        // Get scenario type code from any method possible
        params.scenarioCode = 'RAF'; // Default fallback that works from logs
      }
    }
    
    if (!params.is_issue_key_enabled) {
      params.is_issue_key_enabled = 'N';
    }



    // Convert params to URLSearchParams for form-urlencoded format (like AngularJS)
    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
      formData.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, formData.toString(), httpOptions);
  }
} 